<template>
  <div class="card text-vue" style="width: 802px; max-height: 85%;">
    <div class="card-header text-center">
      <div class="ps-4">
        <h1 class="text-Rot-Schatten fw-bold">Bestellanfrage</h1>
      </div>
      <div class="ps-4">
        Sie haben Fragen oder Wünsche? Das Team des AfM ist gern für Sie da!
      </div>
    </div>
    <div class="card-body scroll p-0 m-0">
      <div class="container-fluid p-0 m-0">
        <div class="row p-0 m-0 bg-Hellgrau">
          <div class="col-md-12 p-0 m-0 text-Weiss bg-Hellgrau">
            <div class="container py-4">
              <!-- Name input -->

              <div class="row mb-3">
                <div class="col-md-6">
                  <label class="form-label" for="emailVorname">Vorname*</label>
                  <input
                    class="form-control"
                    type="text"
                    name="vorname"
                    placeholder="Kaktus"
                    v-model="mail.vorname"
                    v-bind:class="background.vorname"
                    required
                  />
                  <div
                    class="invalid-feedback"
                    data-sb-feedback="vorname:required"
                  >
                    Vorname Address it notwendig.
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="form-label" for="emailNachname"
                    >Nachname*</label
                  >
                  <input
                    class="form-control"
                    type="text"
                    name="nachname"
                    placeholder="Mammillaria"
                    v-model="mail.nachname"
                    v-bind:class="background.nachname"
                    required
                  />
                  <div
                    class="invalid-feedback"
                    data-sb-feedback="nachname:required"
                  >
                    Nachname ist notwendig.
                  </div>
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-md-10">
                  <label class="form-label" for="emailStrasse">Strasse*</label>
                  <input
                    class="form-control"
                    type="text"
                    name="strasse"
                    placeholder="Blumentopf"
                    v-model="mail.strasse"
                    v-bind:class="background.strasse"
                    required
                  />
                  <div
                    class="invalid-feedback"
                    data-sb-feedback="strasse:required"
                  >
                    Strasse is notwendig.
                  </div>
                </div>
                <div class="col-md-2">
                  <label class="form-label" for="emailNummer">Nummer*</label>
                  <input
                    class="form-control"
                    type="text"
                    name="nummer"
                    placeholder="2a"
                    v-model="mail.nummer"
                    v-bind:class="background.nummer"
                    required
                  />
                  <div
                    class="invalid-feedback"
                    data-sb-feedback="nummer:required"
                  >
                    Hausnummer is notwendig.
                  </div>
                </div>
              </div>
              
                <div class="row mb-3">
                  <div class="col-md-2">
                    <label class="form-label" for="emailPLZ">PLZ*</label>
                    <input
                      class="form-control"
                      type="text"
                      name="plz"
                      placeholder="01234"
                      v-model="mail.plz"
                      v-bind:class="background.plz"
                      required
                    />
                    <div
                      class="invalid-feedback"
                      data-sb-feedback="vorname:required"
                    >
                      PLZ is notwendig.
                    </div>
                  </div>
                  <div class="col-md-10">
                    <label class="form-label" for="emailOrt">Ort*</label>
                    <input
                      class="form-control"
                      type="text"
                      name="ort"
                      placeholder="Gewächshaus"
                      v-model="mail.ort"
                      v-bind:class="background.ort"
                      required
                    />
                    <div
                      class="invalid-feedback"
                      data-sb-feedback="vorname:required"
                    >
                      Ort is notwendig.
                    </div>
                  </div>
                </div>

              <!-- Email address input -->
                <div class="row mb-3">
                  <div class="col-md-6">
                    <label class="form-label" for="emailAddress"
                      >Email Adresse*</label
                    >
                    <input
                      class="form-control"
                      type="text"
                      name="email"
                      placeholder="max@example.de"
                      v-model="mail.email"
                      v-bind:class="background.email"
                      required
                    />
                    <div
                      class="invalid-feedback"
                      data-sb-feedback="emailAddress:required"
                    >
                      Email Address it notwendig.
                    </div>
                    <div
                      class="invalid-feedback"
                      data-sb-feedback="emailAddress:email"
                    >
                      Email Address Email ist ungültig.
                    </div>
                  </div>
                  <div class="col-md-6">
                    <label class="form-label" for="emailAddress">Telefon</label>
                    <input
                      class="form-control"
                      type="text"
                      name="telefon"
                      placeholder="03671 12 34 56"
                      v-model="mail.telefon"
                      v-bind:class="background.telefon"
                    />
                  </div>
                </div>

              <!-- Message input -->
              <div class="mb-3">
                <label class="form-label" for="message">Bestellanfrage*</label>
                <textarea
                  class="form-control"
                  id="message"
                  type="text"
                  placeholder="Ihre Bestellanfrage bei uns"
                  style="height: 10rem"
                  v-model="mail.message"
                  v-bind:class="background.message"
                  required
                ></textarea>
                <div
                  class="invalid-feedback"
                  data-sb-feedback="message:required"
                >
                  Message ist notwendig.
                </div>
              </div>

              <!-- Form submissions success message -->
              <div class="d-none" id="submitSuccessMessage">
                <div class="text-center mb-3">Formular wurde gesendet!</div>
              </div>

              <!-- Form submissions error message -->
              <div class="d-none" id="submitErrorMessage">
                <div class="text-center text-danger mb-3">
                  Fehler beim Senden des Formulars!<br />
                  Sie können uns auch unter der Rufnummer: 035208-4765 erreichen
                </div>
              </div>

              <div class="col-md-10 mb-3">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id="andere"
                  v-model="mail.datenschutz"
                  v-bind:class="background.datenschutz"
                  required
                />
                <label class="form-check-label" for="andere"
                  >&nbsp; Ich habe die
                  <a
                    class="text-Weiss text-decoration-underline"
                    href="/Datenschutz"
                    >Datenschutzerklärung</a
                  >
                  zur Kenntnis genommen.
                </label>
                <label class="form-check-label inputerror"> </label>
              </div>
              <div class="col-md-10 mb-3">
                <p>
                  Mit der Lieferung erhalten Sie eine Rechnung und Kontoangaben.
                  Porto und Verpackung wird zum Selbstkostenpreis berechnet.
                </p>
              </div>

              <!-- Form submit button -->
              <div class="d-grid">
                <button
                  class="btn bg-Rot text-Weiss btn-lg"
                  @click="sendMail()"
                  type="submit"
                >
                  Absenden
                </button>
              </div>
              <!--</form>-->
              <div class="col-md-12 mb-3">
                <div class="row">                  
                  <div class="col-12 text-end">
                    <div class="row">
                      <div class="col-md-10">                       
                          Arbeitskreis für Mammillarienfreunde e.V.<br />
                          Uwe Lehmann Vorsitzender<br />
                          Alte Poststr. 48<br />
                          D 01471 Radeburg
                      </div>

                      <div class="col-md-2">
                        
                      </div>
                    </div>
                    <div class="row pt-3">
                      <div class="col-md-10">
                        <a class="text-Schwarz" href="tel:035208-4765"
                          >035208-4765</a
                        >
                      </div>
                      <div class="col-md-2">
                        <i class="fas fa-phone" style="font-size: 18px"></i>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-10">
                        <a
                          class="text-Schwarz"
                          href="mailto:afm-shop@mammillaria.eu"
                          >afm-shop@mammillaria.eu</a
                        >
                      </div>
                      <div class="col-md-2">
                        <i
                          class="fas fas fa-envelope"
                          style="font-size: 18px"
                        ></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal footer -->
    <div class="modal-footer">
      <button type="button" class="btn btn-danger" @click="close()">
        Close
      </button>
    </div>
  </div>
</template>

<script>
import { closeModal } from "jenesius-vue-modal";
import axios from "axios";

export default {
  name: "ModalInhalsverzeichnis",
  data() {
    return {
      newSite: null,
      mail: {
        name: "",
        email: "",
        message: "",
        telefon: "",
        datenschutz: false,
        gesendet: "",
      },
      background: {
        name: "",
        email: "",
        message: "",
        telefon: "",
        datenschutz: "",
      },
    };
  },
  methods: {
    checkEingaben() {
      let re = true;
      if (this.mail.name == "") {
        this.background.name = "border border-2 border-danger";
        re = false;
      } else {
        this.background.name = "border border-2 border-success";
      }
      if (this.mail.email == "") {
        this.background.email = "border border-2 border-danger";
        re = false;
      } else {
        this.background.email = "border border-2 border-success";
      }
      if (this.mail.message == "") {
        this.background.message = "border border-2 border-danger";
        re = false;
      } else {
        this.background.message = "border border-2 border-success";
      }
      if (this.mail.datenschutz == false) {
        this.background.datenschutz = "bg-danger";
        re = false;
      } else {
        this.background.datenschutz = "bg-success";
      }

      return re;
    },
    sendMail() {
      if (this.checkEingaben()) {
        const axiosConfig = {
          headers: {
            Accept: "text/plain",
            "Content-Type": "text/plain",
          },
        };
        const payload = {
          empfaenger: "afm-shop@mammillaria.eu",
          Name: this.mail.name,
          Email: this.mail.email,
          Grund: "Kontaktaufnahme",
          Text: this.mail.message,
          Datenschutz: this.mail.datenschutz,
        };
        let mail = this.mail;
        let background = this.background;
        axios
          .post("https://pillar.de/afm/post_attachment.php", payload, axiosConfig)
          .then((response) => {
            console.log("success", response.data);
            mail.gesendet = "Ihre Kontaktdaten wurden erfolgreich versendet";
            mail.name = "";
            background.name = "";
            mail.email = "";
            background.email = "";
            mail.message = "";
            background.message = "";
            mail.datenschutz = false;
            background.datenschutz = "";
          })
          .catch((error) => {
            console.log(error.response);
            mail.gesendet =
              "Ihre Kontaktdaten konnten leider nicht gesendet werden. Bitte rufen Sie uns an.";
          });
      }
    },
    close() {
      closeModal();
    },
  },
};
</script>
<style>
label {
  text-align: start !important;
}
</style>
